import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
// import { Link } from 'react-router-dom';
import { NavLink, useLocation } from 'react-router-dom';
import logo from '../img/Catus-Tech_Logo-removebg.png';
import './Navbar.css';

function BasicExample() {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false); // <-- control navbar

  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = () => setExpanded(false); // close after click

   // check if current path is one of the Products children
  const isProductsPage = [
    "/AirExportLogisticsSoftware",
    "/SeaExportLogisticsSoftware",
    "/AirImportLogisticsSoftware",
    "/SeaImportLogisticsSoftware",
    "/FinancialAccountingSoftware",
    "/CustomisedBusinessEmailServices",
    "/WebsiteDevelopment"
  ].some(path => location.pathname.startsWith(path));

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      expanded={expanded}               // controlled state
      onToggle={setExpanded}            // keep state in sync
      className={`custom-navbar ${scrolled ? 'scrolled' : ''}`}
      variant="light"
    >
      <Container>
        <Navbar.Brand as={NavLink} to="/" onClick={handleNavClick}>
          <img src={logo} alt="logo" height={60} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-center">
          <Nav className="nav-links">
            <Nav.Link as={NavLink} to="/" className="px-4" onClick={handleNavClick}>Home</Nav.Link>
            <Nav.Link as={NavLink} to="/AboutUs" className="px-4" onClick={handleNavClick}>About Us</Nav.Link>
            <Nav.Link as={NavLink} to="/CatusLMS" className="px-4" onClick={handleNavClick}>Catus LMS</Nav.Link>

            <NavDropdown
              className={`px-4 ${isProductsPage ? "active" : ""}`}
              title="Services"
              popperConfig={{ strategy: "fixed" }}
            >
              <NavDropdown.Item as={NavLink} to="/AirExportLogisticsSoftware" onClick={handleNavClick}>Air Export Logistics Software</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/SeaExportLogisticsSoftware" onClick={handleNavClick}>Sea Export Logistics Software</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/AirImportLogisticsSoftware" onClick={handleNavClick}>Air Import Logistics Software</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/SeaImportLogisticsSoftware" onClick={handleNavClick}>Sea Import Logistics Software</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/FinancialAccountingSoftware" onClick={handleNavClick}>Financial Accounting Software</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/CustomisedBusinessEmailServices" onClick={handleNavClick}>Customised Business Email Services</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/WebsiteDevelopment" onClick={handleNavClick}>Website Development</NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={NavLink} to="/Contact" className="px-4" onClick={handleNavClick}>Contact Us</Nav.Link>
            <Nav.Link as={NavLink} to="/GetQuote" className="px-4" onClick={handleNavClick}>Get A Quote</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default BasicExample;

